import { render, staticRenderFns } from "./BudgetHeader.vue?vue&type=template&id=62dc1d24&"
import script from "./BudgetHeader.vue?vue&type=script&lang=js&"
export * from "./BudgetHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports